import { render } from "./EditTeamMemberModal.vue?vue&type=template&id=5961638e&ts=true"
import script from "./EditTeamMemberModal.vue?vue&type=script&lang=ts"
export * from "./EditTeamMemberModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__